import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setDevMode } from '../redux/reducers/utils/commonReducer';

/**
 * Хук для настройки режима разработки
 * Добавляет глобальную функцию dev() для включения/выключения dev-режима
 */
const useDevMode = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const dev = (enable = true) => {
      dispatch(setDevMode(enable));
      console.log(`Dev mode ${enable ? '✅ enabled' : '❌ disabled'}`);
      return enable;
    };

    // Добавляем глобальную функцию для удобства
    window.dev = dev;

    // Очистка при размонтировании
    return () => {
      delete window.dev;
    };
  }, [dispatch]);
};

export default useDevMode;
